import type { CSSObject } from '@emotion/react'
import { Input } from '@mantine/core'
import { IconSearch } from 'components/icons/IconSearch'
import type { ChangeEvent } from 'react'
import { useState } from 'react'

export const useSearchInput = ({
  placeholder = '',
  maxWidth = 300,
}: {
  placeholder?: string
  maxWidth?: CSSObject['maxWidth']
}) => {
  const [searchString, setSearchString] = useState('')

  const SearchInput = (
    <Input
      css={{ maxWidth }}
      leftSection={<IconSearch />}
      placeholder={placeholder}
      onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchString(e.target.value)}
      value={searchString}
    />
  )

  return {
    SearchInput,
    searchString,
    setSearchString,
  }
}
